import {
  Box,
  Container,
  Typography,
  Paper,
  Chip,
  LinearProgress,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  StarBorderRounded,
  TrendingUpRounded,
  CheckRounded,
  WarningAmberRounded,
  RadioButtonCheckedRounded,
} from "@mui/icons-material";
import { palette, theme  as colorTheme} from "../../../../Convoze.theme";
import { purple } from "@mui/material/colors";



const ui = {
  // bg: "#0b0b0f",
  bg : colorTheme('palette', 'night').value,
  // text: "#e5e7eb",
  // text :colorTheme('palette', 'white').value,
  text:"black",
  // subtext: "#9aa0a6",
  // subtext:colorTheme('palette', 'secondary').value,
  subtext:"black",
  // card: "#0f1014",
  // card :colorTheme('palette', 'night').value,
  card :"black",
  // border: "#1f1f23",
  // border :colorTheme('palette', 'night').value,
  border :"black",
  // barBg: "#1b1c24",
  barBg :colorTheme('palette', 'night').value,
  // purple: "#7c3aed",
  purple :colorTheme('palette', 'primary').value,
  // purpleLight: "#a78bfa",
  purpleLight:colorTheme('palette', 'primaryBg').value,
  // green: "#10b981",
  green :colorTheme('palette', 'positive').value,
  // yellow: "#fbbf24",
  yellow :colorTheme('palette', 'neutral').value,
  // blue: "#60a5fa",
  blue:colorTheme('palette', 'agent').value
};

const Bar = styled(LinearProgress)({
  height: 7,
  borderRadius: 12,
  backgroundColor: "#DAD6D6",
  "& .MuiLinearProgress-bar": {
    borderRadius: 12,
    // background: `linear-gradient(90deg, #6366F1 0%, #9495dcff 50%, #a78bfa 100%)`,
    background:colorTheme('palette', 'primary').value
  },
});

function SectionCard({ title, icon, children, sx, textAlignCenter }) {
  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: "#FDFDFF",
        border: `1px solid #F1F1F3`,
        borderRadius: 5,
        p: { xs: 1.5, sm: 2 },
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.25,
          mb: { xs: 1.25, sm: 1.75 },
          justifyContent: textAlignCenter && "center",
        }}
      >
        {icon}
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, fontSize: "1rem", lineHeight: "1.75rem" }}
        >
          {title}
        </Typography>
      </Box>
      {children}
    </Paper>
  );
}

function QualityChip({ quality }) {

  const map = {
    Excellent: {
      label: "Excellent",
      // color: "#22c55e",
      color:colorTheme('palette', 'positive').value,
      // bg: "rgba(34,197,94,.14)",
      // bd: "rgba(34,197,94,.35)",
      bg:colorTheme('palette', 'positiveBg').value,
      bd:colorTheme('palette', 'positive').value
    },
    Good: {
      label: "Good",
      // color: "#8b5cf6",
      color:colorTheme('palette', 'primary').value,
      // bg: "rgba(139,92,246,.14)",
      // bd: "rgba(139,92,246,.35)",
      bg:colorTheme('palette', 'primaryBg').value,
      bd:colorTheme('palette', 'primary').value
    },
    Fair: {
      label: "Fair",
      // color: "#f59e0b",
      // color:colorTheme('palette', 'neutral').value,
      color:"black",
      // bg: "rgba(245,158,11,.16)",
      // bd: "rgba(245,158,11,.35)",
      bg:colorTheme('palette', 'neutralBg').value,
      bd:colorTheme('palette', 'neutral').value
    },
    NeedsImprovement: {
      // 👈 fix key here
      label: "Needs Improvement",
      // color: "#e84524ff",
      color:colorTheme('palette', 'negative').value,
      // bg: "#f6cbc2ff",
      // bd: "#f47723ff",
      bg:colorTheme('palette', 'negativeBg').value,
      bd:colorTheme('palette', 'negative').value
    },
  };

  const c = map[quality.replace(/\s/g, "")];

  return (
    <Chip
      size="small"
      label={c?.label}
      icon={<RadioButtonCheckedRounded sx={{ fontSize: 14 }} />}
      sx={{
        height: 24,
        bgcolor: c?.bg,
        color: c?.color,
        fontSize: "0.75rem",
        lineHeight: "1rem",
        "& .MuiChip-icon": { color: c?.color, ml: 0.5 },
        fontWeight: 600,
        fontSize: "0.75rem",
        lineHeight: "1rem",
      }}
    />
  );
}

function TargetChip({ met }) {
  return (
    <Chip
      size="small"
      label={met ? "Achieved" : "Below Target"}
      icon={met ? <CheckRounded /> : <WarningAmberRounded />}
      sx={{
        height: 24,
        bgcolor: "#fff",
        color: met ? ui.green : ui.yellow,
        border: `1px solid ${
          met ? ui.green : ui.yellow
        }`,
        "& .MuiChip-icon": { color: met ? ui.green :ui.yellow, ml: 0.5 },
        fontWeight: 600,
      }}
    />
  );
}

function WeightChip({ weight }) {
  return (
    <Chip
      size="small"
      label={`Weight: ${weight}%`}
      sx={{
        height: 22,
        bgcolor: "rgba(148,163,184,.14)",
        color: ui.text,
        border: "1px solid rgba(148,163,184,.35)",
        "& .MuiChip-label": { px: 0.75 },
        fontWeight: 700,
      }}
    />
  );
}

function ParamRow({ p }) {

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 5,
        p: { xs: 1.25, sm: 1.75 },
        mb: 1.25,
        backgroundColor: " #FAFAFB",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          gap: 1,
          flexWrap: "wrap",
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 600, fontSize: "0.9rem" }}
          >
            {p?.name}
          </Typography>
          <Chip
            size="small"
            label={`Score: ${p?.score}%`}
            sx={{
              height: 22,
              bgcolor: "#fff",
              border: "1px solid rgba(148,163,184,.35)",
              "& .MuiChip-label": { px: 0.75 },
              fontWeight: 600,
              fontSize: "0.75rem",
            }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <QualityChip quality={p?.quality} />
          {/* <TargetChip met={met} /> */}
          {/* <Chip
            size="small"
            label={p?.quality}
            icon={<RadioButtonCheckedRounded sx={{ fontSize: 14 }} />}
            sx={{
              height: 24,
            //   bgcolor: c?.bg,
            //   color: c?.color,
              fontSize: "0.75rem",
              lineHeight: "1rem",
            //   "& .MuiChip-icon": { color: c?.color, ml: 0.5 },
              fontWeight: 600,
              fontSize: "0.75rem",
              lineHeight: "1rem",
            }}
          /> */}
        </Box>
      </Box>
      {/* 
      <Typography
        variant="caption"
        sx={{
          color: "#71717A",
          display: "block",
          mt: 0.75,
          mb: 0.75,
          fontSize: "0.75rem",
          //   fontWeight: 600,
        }}
      >
        Target: <strong>{p.target}%</strong>
      </Typography> */}

      <Bar value={p.score} height={8} variant="determinate" />
    </Paper>
  );
}

export default function ScoreCard({ agentKpisData }) {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));

  const overall = 94;

  const params = [
    {
      name: "Communication Skills",
      weight: 25,
      score: agentKpisData?.skillsAnalysis?.CommunicationSkills || 0,
      target: 85,
      quality:
        agentKpisData?.skillsAnalysis?.CommunicationSkills > 80
          ? "Excellent"
          : agentKpisData?.skillsAnalysis?.CommunicationSkills > 60
          ? "Good"
          : agentKpisData?.skillsAnalysis?.CommunicationSkills > 40
          ? "Fair"
          : "Needs Improvement",
    },
    {
      name: "Product Knowledge",
      weight: 20,
      score: agentKpisData?.parameterBreakdown?.ProductKnowledge || 0,
      target: 90,
      quality:
        agentKpisData?.parameterBreakdown?.ProductKnowledge > 80
          ? "Excellent"
          : agentKpisData?.parameterBreakdown?.ProductKnowledge > 60
          ? "Good"
          : agentKpisData?.parameterBreakdown?.ProductKnowledge > 40
          ? "Fair"
          : "Needs Improvement",
    },
    {
      name: "Problem Resolution",
      weight: 30,
      score: agentKpisData?.parameterBreakdown?.ProblemResolution || 0,
      target: 85,
      quality:
        agentKpisData?.parameterBreakdown?.ProblemResolution > 80
          ? "Excellent"
          : agentKpisData?.parameterBreakdown?.ProblemResolution > 60
          ? "Good"
          : agentKpisData?.parameterBreakdown?.ProblemResolution > 40
          ? "Fair"
          : "Needs Improvement",
    },
    {
      name: "Technical Knowledge",
      weight: 15,
      score: agentKpisData?.skillsAnalysis?.TechnicalKnowledge,
      target: 80,
      quality:
        agentKpisData?.skillsAnalysis?.TechnicalKnowledge > 80
          ? "Excellent"
          : agentKpisData?.skillsAnalysis?.TechnicalKnowledge > 60
          ? "Good"
          : agentKpisData?.skillsAnalysis?.TechnicalKnowledge > 40
          ? "Fair"
          : "Needs Improvement",
    },
    {
      name: "Customer Service",
      weight: 10,
      score: 97,
      target: 95,
      quality:
        agentKpisData?.skillsAnalysis?.CustomerService > 80
          ? "Excellent"
          : agentKpisData?.skillsAnalysis?.CustomerService > 60
          ? "Good"
          : agentKpisData?.skillsAnalysis?.CustomerService > 40
          ? "Fair"
          : "Needs Improvement",
    },
  ];

  return (
    <Box sx={{}}>
      {/* Title Row */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
        <Typography
          variant={"h2"}
          sx={{
            fontSize: "1.125rem",
            fontWeight: 700,
            // background: `linear-gradient(90deg, #6366F1 0%, #9495dcff 50%, #a78bfa 100%)`,
            background:colorTheme('palette', 'primary').value,
            lineHeight: "1.75rem",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            color: "transparent",
          }}
        >
          Performance Report Card
        </Typography>
        <Chip
          size="small"
          label="Improving"
          icon={<TrendingUpRounded sx={
            // { color: "#22c55e !important" }
            {color :`${colorTheme('palette', 'positive').value} !important`}
          } />}
          sx={{
            height: 22,
            bgcolor: "#E8F9EE",
            // color: " #22c55e",
            color:colorTheme('palette', 'positive').value,
            fontWeight: 500,
            fontSize: "0.75rem",
          }}
        />
      </Box>

      {/* Overall Score */}
      <SectionCard
        title="Overall Performance Score"
        icon={<StarBorderRounded sx={
          { color: ui.purple, fontSize: 32 }
        } />}
        textAlignCenter="center"
      >
        <Box sx={{ textAlign: "center", mb: 1 }}>
          <Typography
            variant={isSm ? "h5" : "h4"}
            sx={{
              color: ui.purple,
              fontWeight: 700,
              fontSize: "2.25rem",
              lineHeight: "2.5rem",
              letterSpacing: 0.3,
            }}
          >
            {agentKpisData?.averageOverallParameterScore
              ? `${agentKpisData?.averageOverallParameterScore}%`
              : 0}
          </Typography>
        </Box>
        <Bar
          value={
            agentKpisData?.averageOverallParameterScore
              ? agentKpisData?.averageOverallParameterScore
              : 0
          }
          variant="determinate"
        />
      </SectionCard>

      {/* Parameter Breakdown */}
      <SectionCard
        icon={<RadioButtonCheckedRounded sx={{ color:ui.purple }} />}
        title="Parameter Breakdown"
        sx={{ mt: 2 }}
      >
        {params?.map((p) => (
          <ParamRow key={p.name} p={p} />
        ))}
      </SectionCard>
    </Box>
  );
}
